import Vue from 'vue'
// import App from './App'
import AppV2 from './App'
// import router from './router'
import router from './router'
import store from './store'

import '@/filters'
import '@/directives'

import '@/plugins/bootstrap-vue'
import '@/plugins/vuelidate'
import '@/plugins/vue-meta'
import '@/plugins/v-mask'

import i18n from '@/plugins/vue-i18n'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(AppV2)
}).$mount('#app')
